var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, e_1, _22;
import { __read, __spreadArray, __values } from "tslib";
export var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["DE"] = "de";
})(Language || (Language = {}));
var Resources = /** @class */ (function () {
    function Resources(defaultLanguage, definition) {
        var e_2, _a, e_3, _b;
        this.defaultLanguage = defaultLanguage;
        this.language = defaultLanguage;
        this.map = new Map();
        try {
            // create an object with language specific strings per language and store them to our map
            for (var _c = __values(Object.keys(definition)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                try {
                    for (var _e = (e_3 = void 0, __values(Object.keys(definition[key]))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var lang = _f.value;
                        var value = definition[key][lang];
                        if (value) {
                            var languageSpecificStrings = this.map.get(lang);
                            if (!languageSpecificStrings) {
                                languageSpecificStrings = {};
                                this.map.set(lang, languageSpecificStrings);
                            }
                            languageSpecificStrings[key] = value;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    Resources.prototype.getStrings = function () {
        return this.map.get(this.language) || this.map.get(this.defaultLanguage);
    };
    Object.defineProperty(Resources.prototype, "supportedLanguages", {
        get: function () {
            return __spreadArray([], __read(this.map.keys()));
        },
        enumerable: false,
        configurable: true
    });
    return Resources;
}());
export { Resources };
export var resources = new Resources(Language.DE, {
    InitiatePayment: (_a = {},
        _a[Language.EN] = "Initiate payment. Please wait...",
        _a[Language.DE] = "Zahlung wird vorbereiten. Bitte warten... ",
        _a),
    InvalidPayment: (_b = {},
        _b[Language.EN] = "Could not start payment. Please contact support!",
        _b[Language.DE] = "Fehler beim starten der Zahlung. Bitte kontaktieren Sie uns.",
        _b),
    SelectPaymentMethod: (_c = {},
        _c[Language.EN] = "Please select your payment method:",
        _c[Language.DE] = "Bitte wählen Sie Ihre Zahlungsmethode aus:",
        _c),
    StorePaymentMethodCards: (_d = {},
        _d[Language.EN] = "Stored Credit Card",
        _d[Language.DE] = "Gespeicherte SEPA-Lastschriftverfahren",
        _d),
    StorePaymentMethodSepaDirectDebit: (_e = {},
        _e[Language.EN] = "Stored SEPA Direct Debit",
        _e[Language.DE] = "Gespeicherte Kreditkarte",
        _e),
    PaymentMethodCards: (_f = {},
        _f[Language.EN] = "Credit Card",
        _f[Language.DE] = "Kreditkarte",
        _f),
    PaymentMethodCardsDescription: (_g = {},
        _g[Language.EN] = "Mastercard, VISA, Diners Club, etc.",
        _g[Language.DE] = "Mastercard, VISA, Diners Club, usw.",
        _g),
    PaymentMethodSepaDirectDebit: (_h = {},
        _h[Language.EN] = "SEPA Direct Debit",
        _h[Language.DE] = "SEPA-Lastschriftverfahren",
        _h),
    PaymentMethodSepaDirectDebitDescription: (_j = {},
        _j[Language.EN] = "For customers in the Single Euro Payments Area.",
        _j[Language.DE] = "Für Kunden im einheitlichen Euro-Zahlungsraum.",
        _j),
    PaymentMethodNotSupported: (_k = {},
        _k[Language.EN] = "Sorry! We don't support your selected payment method yet. Please try again with a different one.",
        _k[Language.DE] = "Leider unterstützen wir Ihre gewählte Zahlungsmethode noch nicht. Bitte versuchen Sie noch einmal mit einer andere Zahlungsmethode.",
        _k),
    PaymentFormCardsDescription: (_l = {},
        _l[Language.EN] = "Please provider us your card information:",
        _l[Language.DE] = "Bitte geben Sie uns Ihre Karteninformationen:",
        _l),
    PaymentFormSavePaymentMethod: (_m = {},
        _m[Language.EN] = "Save my current payment method for next checkout.",
        _m[Language.DE] = "Bitte meine Zahlungsmethode speichern für die nächsten Zahlungen.",
        _m),
    PaymentFormSepaDirectDebitAcceptance: (_o = {},
        _o[Language.EN] = "By providing the IBAN and confirming this payment, I authorize/ We authorize (A) %PAYEE% to collect payments from my/our bank account by SEPA Direct Debit. At the same time (B) I/we instruct my/our credit institution to honour the direct debits drawn by %PAYEE% to my/our bank account.",
        _o[Language.DE] = "Durch Angabe der IBAN und Bestätigung dieser Zahlung, ich ermächtige/ Wir ermächtigen (A) %PAYEE%, Zahlungen von meinem/ unserem Konto mittels Lastschrift einzuziehen. Zugleich (B) weise ich mein/ weisen wir unser Kreditinstitut an, die von %PAYEE% auf mein/ unser Konto gezogenen Lastschriften einzulösen.",
        _o),
    ProcessingPayment: (_p = {},
        _p[Language.EN] = "Processing your payment. Please wait...",
        _p[Language.DE] = "Ihrer Zahlung wird bearbeiten. Bitte warten...",
        _p),
    PaymentCanceled: (_q = {},
        _q[Language.EN] = "Payment canceled.",
        _q[Language.DE] = "Die Zahlung wurde storniert.",
        _q),
    PaymentSucceeded: (_r = {},
        _r[Language.EN] = "Payment succeeded. Thank you very much.",
        _r[Language.DE] = "Zahlung erfolgt. Vielen Dank.",
        _r),
    PaymentInProcessing: (_s = {},
        _s[Language.EN] = "Your payment is being processed...",
        _s[Language.DE] = "Ihre Zahlung wird bearbeitet...",
        _s),
    PaymentFailed: (_t = {},
        _t[Language.EN] = "There was a fail attempt when charging your payment.",
        _t[Language.DE] = "Es gab einen Fehlversuch bei der Bearbeitung Ihrer Zahlung.",
        _t),
    PaypalFailedToLoad: (_u = {},
        _u[Language.EN] = "Could not load PayPal payment method. Please try a different method.",
        _u[Language.DE] = "Leider können wir die PayPal-Zahlungsmethode nicht laden. Bitte versuchen Sie eine andere Methode.",
        _u),
    PaypalFailedToCreateOrder: (_v = {},
        _v[Language.EN] = 'Could not create order for PayPal payment.',
        _v[Language.DE] = 'Leider können wir keine Bestellung mit PayPal-Zahlung erstellen.',
        _v),
    PaypalFailedToCaptureOrder: (_w = {},
        _w[Language.EN] = 'Could not capture PayPal payment.',
        _w[Language.DE] = 'Leider können wir Ihre PayPal-Zahlung nicht bearbeiten.',
        _w),
    Amount: (_x = {},
        _x[Language.EN] = "Amount",
        _x[Language.DE] = "Betrag",
        _x),
    Name: (_y = {},
        _y[Language.EN] = "Name",
        _y[Language.DE] = "Name",
        _y),
    Email: (_z = {},
        _z[Language.EN] = "Email Address",
        _z[Language.DE] = "E-Mail-Adresse",
        _z),
    Loading: (_0 = {},
        _0[Language.EN] = "Loading...",
        _0[Language.DE] = "Laden...",
        _0),
    Finish: (_1 = {},
        _1[Language.EN] = "Finish",
        _1[Language.DE] = "Beenden",
        _1),
    Back: (_2 = {},
        _2[Language.EN] = "Back",
        _2[Language.DE] = "Zurück",
        _2),
    Cancel: (_3 = {},
        _3[Language.EN] = "Cancel",
        _3[Language.DE] = "Abrechen",
        _3),
    ReturnToMerchant: (_4 = {},
        _4[Language.EN] = "Return to merchant.",
        _4[Language.DE] = "Zurück zum Händler.",
        _4),
    CancelAndReturnToMerchant: (_5 = {},
        _5[Language.EN] = "Cancel and return to merchant.",
        _5[Language.DE] = "Abbrechen und zurück zum Händler.",
        _5),
    ErrorCodeInvalidPayee: (_6 = {},
        _6[Language.EN] = 'Payment contains an invalid payee.',
        _6[Language.DE] = 'Die Zahlung enthält einen ungültigen Zahlungsempfänger.',
        _6),
    ErrorCodePayeeNotConfiguredForStripe: (_7 = {},
        _7[Language.EN] = 'Payment methods (Cards) not supported.',
        _7[Language.DE] = 'Zahlungsmethoden (Cards) werden nicht unterstützt.',
        _7),
    ErrorCodePayeeNotConfiguredForPayPal: (_8 = {},
        _8[Language.EN] = 'Payment method (PayPal) not supported.',
        _8[Language.DE] = 'Zahlungsmethode (PayPal) wird nicht unterstützt.',
        _8),
    ErrorCodePayeeRetrieveError: (_9 = {},
        _9[Language.EN] = 'Payee not existed.',
        _9[Language.DE] = 'Zahlungsempfänger nicht existiert.',
        _9),
    ErrorCodeInvalidPayer: (_10 = {},
        _10[Language.EN] = 'Invalid payer.',
        _10[Language.DE] = 'Ungültiger Zahler.',
        _10),
    ErrorCodePayerRetrieveError: (_11 = {},
        _11[Language.EN] = 'Payer not existed.',
        _11[Language.DE] = 'Zahler nicht existiert.',
        _11),
    ErrorCodePayerSaveMethodError: (_12 = {},
        _12[Language.EN] = 'Failed to store payment method.',
        _12[Language.DE] = 'Die Zahlungsmethode konnte nicht gespeichert werden.',
        _12),
    ErrorCodeInvalidMinimumAmount: (_13 = {},
        _13[Language.EN] = 'Payment amount falls below minimum amount.',
        _13[Language.DE] = 'Der Zahlungsbetrag fällt unter den Mindestbetrag.',
        _13),
    ErrorCodeInvalidEmail: (_14 = {},
        _14[Language.EN] = 'Invalid email address. Please check your user data.',
        _14[Language.DE] = 'Ungültige E-Mail-Adresse. Bitte überprüfen Sie Ihre Benutzerdaten.',
        _14),
    ErrorCodePaymentUseStoredMethodError: (_15 = {},
        _15[Language.EN] = 'Failed to use stored payment method.',
        _15[Language.DE] = 'Die gespeicherte Zahlungsmethode konnte nicht verwendet werden.',
        _15),
    ErrorCodePaymentRetrieveError: (_16 = {},
        _16[Language.EN] = 'Payment not existed.',
        _16[Language.DE] = 'Zahlung nicht existiert.',
        _16),
    ErrorCodePaymentCreationError: (_17 = {},
        _17[Language.EN] = 'Failed to create payment.',
        _17[Language.DE] = 'Die Zahlung konnte nicht erstellt werden.',
        _17),
    ErrorCodePaymentCreateStripeMethodError: (_18 = {},
        _18[Language.EN] = 'Failed to initiate payment (Cards). Please contact support.',
        _18[Language.DE] = 'Die Zahlung könnte nicht starten (Cards). Bitte kontaktieren Sie den Support.',
        _18),
    ErrorCodePaymentCreatePayPalMethodError: (_19 = {},
        _19[Language.EN] = 'Failed to initiate payment (PayPal). Please contact support.',
        _19[Language.DE] = 'Die Zahlung könnte nicht starten (PayPal). Bitte kontaktieren Sie den Support.',
        _19),
    ErrorCodePaymentCapturePayPalError: (_20 = {},
        _20[Language.EN] = 'Failed to captured PayPal amount. Please contact support.',
        _20[Language.DE] = 'Der PayPal-Betrag konnte nicht erfasst werden. Bitte kontaktieren Sie den Support.',
        _20),
    ErrorOccurred: (_21 = {},
        _21[Language.EN] = "An error occurred. Code:",
        _21[Language.DE] = "Ein Fehler ist aufgetreten. Code:",
        _21)
});
// try to push preferred user language
var languages = navigator.languages || [navigator.language || navigator.userLanguage];
try {
    for (var languages_1 = __values(languages), languages_1_1 = languages_1.next(); !languages_1_1.done; languages_1_1 = languages_1.next()) {
        var language = languages_1_1.value;
        var langCode = language.substr(0, 2);
        var index = resources.supportedLanguages.indexOf(langCode);
        if (index >= 0) {
            resources.language = resources.supportedLanguages[index];
            break;
        }
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (languages_1_1 && !languages_1_1.done && (_22 = languages_1.return)) _22.call(languages_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=resources.js.map